import { LoyaltyLevelRewardButtonVariant } from "./types";

export const DESCRIPTIONS_CARD: Record<
  LoyaltyLevelRewardButtonVariant,
  { description: string; placeholder: string }
> = {
  prev: {
    description: "loyalty.redesign.1.card.rank.subtitle.prev",
    placeholder: "loyalty.redesign.1.card.rank.placeholder.prev",
  },
  current: {
    description: "loyalty.redesign.1.card.rank.subtitle.current",
    placeholder: "",
  },
  next: {
    description: "loyalty.redesign.1.card.rank.subtitle.next",
    placeholder: "loyalty.redesign.1.card.rank.placeholder.next",
  },
};
